import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCalidad = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'calidad',
        name: 'Calidad',
        component: ViewCalidad,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
